<div class="container-box" [class.thin-gray-border]="!topBorderOnly" [class.top-border]="topBorderOnly">
  <label class="floating-label accent-color" [class.opacity-0]="!headerTitle">
    {{ headerTitle }}
    <mat-icon *ngIf="helpComponent" [inline]="true" (click)="onHelpClicked()" color="primary"
      class="info-icon-button help-icon" matRipple>help_outline</mat-icon>
  </label>
  <div *ngIf="isLoading" class="m-16 flex-center">
    <mat-spinner color="accent" diameter="32"></mat-spinner>
  </div>
  <div class="content" *ngIf="dataItems">
    <div *ngFor="let item of dataItems; let i = index" class="data-item" [class.left-divider-1]="i > 0">
      <div class="value-2 text-center" [class.font-medium]="item.style" [class.success-color]="item.style === 'success'"
        [class.caution-color]="item.style === 'caution'" [class.warn-color]="item.style === 'warning'">
        {{ item.value }}
      </div>
      <div class="label-3 pt-25">{{ item.label }}</div>
    </div>
  </div>

  <!-- For providing own content instead of data item array. -->
  <ng-content></ng-content>
</div>